import {useBioMatchMarkers} from './useBioMatchMarkers';

/**
 * Single source of truth for "does the BioMatch hero render a card?".
 * CustomBioMatchHero AND anything that must appear only alongside it
 * (the My Labs Plus card, per Derrick 2026-08-11 — a membership upsell
 * with no kit offer next to it is an orphan) share this predicate so
 * the two can never drift.
 */

/** Curated "BioMatched For You" cards are temporarily hidden (2026-07-29):
 *  products now live inside the custom package; standalone cards would
 *  double-sell. Flip to re-enable — the hero and this predicate both key
 *  off the same constant. */
export const SHOW_CURATED_CARDS: boolean = false;

export function hasBioMatchCardContent(state: {
    isLoading: boolean;
    isError: boolean;
    customPackage: unknown | null;
    product: unknown | null;
    curatedCards: unknown[];
}): boolean {
    if (state.isLoading) return false;
    // Deliberately NOT gated on isError: React Query v5 sets isError on a
    // failed background refetch while the cached data stays renderable.
    // Hiding on error made the card (and the My Labs Plus card riding on
    // this predicate) vanish mid-session whenever one silent refetch
    // failed. With no cached data, customPackage/product are null and the
    // card hides through the content check below anyway.
    // v11 card is entirely product-driven — package without a product renders nothing.
    const showCustomCard = Boolean(state.customPackage && state.product);
    return showCustomCard || (SHOW_CURATED_CARDS && state.curatedCards.length > 0);
}

/** Hook form for components outside the hero (React Query dedupes the fetch). */
export function useHasBioMatchCard(): boolean {
    const {isLoading, isError, customPackage, product, curatedCards} = useBioMatchMarkers();
    return hasBioMatchCardContent({isLoading, isError, customPackage, product, curatedCards});
}
